var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.$t('Anonymní obsah')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }